// extracted by mini-css-extract-plugin
export default {"center":"Refund_center__UdWDI","header":"Refund_header__pN4pv","items":"Refund_items__6FD7A","content":"Refund_content__RiZ-I"};